import { fetchPositions, fetchHoldings, convertPosition } from "../../services/backendAPI/index";
import {
  getFormattedPosition,
  getFormattedHolding,
} from "../../utils/portfolio";
import {fetchOrder, getAllIpo, cancelAMOOrder} from "../../services/backendAPI";



export const fetchPositionsAction = (
  positionType='historical',
  isBackOfficeEnabled,
  oms
) => (dispatch, getState) => {
  dispatch({ type: 'FETCH_POSITIONS_REQUEST' });
  return fetchPositions(positionType)
    .then(({ data }) => {
      const currentPositions = getState().portfolio.arrPositionsData;

      const positions = data.map((position) => {
        // Tag with isLtpStale to show skeleton until websocket update
        position.isLtpStale = true;
        let ltpToUse = position.ltp;

        if (currentPositions && currentPositions.length > 0) {
          const existingPosition = currentPositions.find(
            p => (p.token === position.token || p.instrument_token === position.instrument_token) 
              && p.exchange === position.exchange
          );

          if (existingPosition && !existingPosition.isLtpStale) {
            // We already have a live WS tick! DO NOT overwrite it with stale REST data!
            ltpToUse = existingPosition.ltp;
            position.isLtpStale = false; // Prevents the random skeleton loader flashes!
          }
        }

        // Pass ltp as the second parameter - this is critical for PnL calculation
        const formattedPosition = getFormattedPosition(
          position, 
          ltpToUse, 
          positionType, 
          isBackOfficeEnabled, 
          oms
        );
        
        return formattedPosition;
      });
      
      dispatch({
        type: "SET_POSITIONS",
        payload: positions,
      });
      dispatch({
        type: "SET_POSITIONS_UPDATE",
        payload: positions,
      });
    })
    .catch((err) => dispatch({
      type: 'SET_POSITIONS_ERROR_MESSAGE',
      payload: err
    }));
};

export const fetchHoldingsAction = (oms, brokerName, quantityConfig, productCode) => (dispatch) => {
  fetchHoldings(productCode)
    .then(({ data }) => {
      const holdings = data.holdings.map((holding) =>
        getFormattedHolding(holding, oms, brokerName, quantityConfig)
      );
      dispatch({
        type: "SET_HOLDINGS",
        payload: holdings,
      });
      dispatch({
        type: "SET_HOLDINGS_UPDATE",
        payload: holdings,
      });
    })
    .catch((err) => dispatch({
      type: 'SET_HOLDINGS_ERROR_MESSAGE',
      payload: err
    }));
};

export const executeConvertPositionAction = (position, quantity, targetProduct) => dispatch => {
  if (!position || !quantity || !targetProduct) {
    console.error("Missing parameters:", { position, quantity, targetProduct });
    throw new Error(`Missing required parameters: ${!position ? 'position' : ''} ${!quantity ? 'quantity' : ''} ${!targetProduct ? 'targetProduct' : ''}`);
  }

  const payload = {
    product: position.product,
    exchange: position.exchange,
    quantity: quantity,
    validity: position.cf_buy_quantity > 0 ? "CF" : "DAY",
    // instrument_type: "FUTCOM",
    client_id: localStorage.getItem("login_id"),
    order_side: position.net_quantity > 0 ? "SELL" : "BUY",
    new_product: targetProduct,
    instrument_token: position.token
  };
  return convertPosition(payload)
    .then((response) => {
      dispatch({
        type: 'SET_CONVERT_POSITION',
        payload: response.data
      });
      return response;
    })
    .catch(err => {
      console.error('Position conversion error:', err);
      throw err;
    });
};

export const fetchAllIPOsAction = () => dispatch => {
  getAllIpo()
    .then(({data}) => {
      dispatch({
        type: 'SET_ALL_IPOS',
        payload: data
      })
    })
    .catch(err => console.log(err));
}

export const fetchOrdersAction = () => dispatch => {
  fetchOrder()
    .then(({data}) => {
      dispatch({
        type: 'SET_IPO_ORDERS',
        payload: data
      })
    })
    .catch(err => console.log(err));
}
export const fetchAMOOrdersAction = () => dispatch => {
  cancelAMOOrder()
    .then(({data}) => {
      dispatch({
        type: 'SET_AMO_IPO_ORDERS',
        payload: data
      })
    })
    .catch(err => console.log(err));
}
